import { query } from 'gql-query-builder';

export const authUserFindMeQuery = () =>
  query([
    {
      operation: 'user_find_me',
      fields: ['payrollNumber, name, profile'],
    },
  ]);
